<template>
  <span
    v-show="rendered"
    class="warn-user"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12 2L1 21h22M12 6l7.53 13H4.47M11 10v4h2v-4m-2 6v2h2v-2"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'userIcon',
  serverCacheKey: () => 'userIcon',
  data: () => ({
    rendered: false
  }),

  mounted() {
    this.rendered = true
  }
}
</script>

<style lang="scss">
.warn-user {
  display: inline-block;
  width: 32px;
  height: 32px;
  fill: #fff;
  text-shadow: rgba(0, 0, 0, 0.2) 0px 1px 0px;
  transition: transform 0.2s ease-in-out;
}
</style>
